import { FW_VERSION, MODEL_KEY } from "./Firmwares";

// 아래 버전보다 작거나 같으면 카메라 세팅메뉴 내 Live Event Upload / Push notifications / Firmware 설정 지원안함 (disable) (7103)
export const CAMERA_SETTING_UNSUPPORTED: { [key in MODEL_KEY]?: FW_VERSION } = {
  "DR750S-1CH": 1.017,
  "DR750S-2CH": 1.017,
  "DR900S-1CH": 1.012,
  "DR900S-2CH": 1.012,
  "DR750G-1CH": 1.002,
  "DR750G-2CH": 1.002,
  "DR750-2CH LTE": 1.006,
  "DR750X-1CH": 1.005,
  "DR750X-2CH": 1.005,
  "DR900X-1CH": 1.005,
  "DR900X-2CH": 1.005,
  "DR750G-1CH Pro": 1.0,
  "DR750G-2CH Pro": 1.0,
  "DR750X Plus": 1.0,
  "DR750G Pro": 1.0,
};

export const DMC100_MODELS: MODEL_KEY[] = ["DR750X-3CH Plus"];
export const DMC200_MODELS: MODEL_KEY[] = [
  "DR750X LTE Plus",
  "DR750X Plus",
  "DR900X Plus",
  "DR770X",
];
// export const DMC200_MODELS: MODEL_KEY[] = []; // DMS출시전
export const MODELS_1CH: MODEL_KEY[] = [
  "DR750S-1CH",
  "DR900S-1CH",
  "DR750G-1CH",
  "DR750X-1CH",
  "DR900X-1CH",
  // "DR590X-1CH",
  "DR750G-1CH Pro",
];

export const MODELS_2CH: MODEL_KEY[] = [
  "DR750S-2CH",
  "DR900S-2CH",
  "DR750G-2CH",
  "DR750-2CH LTE",
  "DR750X-2CH",
  "DR900X-2CH",
  // "DR590X-2CH",
  "DR750G-2CH Pro",
  "DR750X Plus",
  // "DR750LTE Plus",
  "DR900X Plus",
  "DR750G Pro",
  "DR750X LTE Plus",
  // "DR750K LTE",
  "DR770X",
  "DR770X LTE",
  "BlackVue 7G Pro",
  "DR970X",
  "DR970X LTE",
  "DR800 GOLD",
];

export const MODELS_3CH: MODEL_KEY[] = ["DR750X-3CH Plus", "DR770X Box"];
export const LOW_VOLTAGE_MODELS: MODEL_KEY[] = [
  "DR750X-1CH",
  "DR900X-1CH",
  // "DR590X-1CH",
  "DR750X-2CH",
  "DR900X-2CH",
  // "DR590X-2CH",
  "DR750X Plus",
  "DR900X Plus",
  "DR750X-3CH Plus",

  "DR770X",
  "DR770X Box",
  "DR770X LTE",
  "BlackVue 7G Pro",
  "DR970X",
  "DR970X LTE",
  // mantis - 10635 시그마 DR800Gold 모델 Low voltage warning항목 노출되도록 추가(Leehj)
  "DR800 GOLD",
  // mantis - 10584, DR750X LTE Plus모델 Low voltage warning항목 노출되도록 추가(Leehj)
  "DR750X LTE Plus",
];

export const BATTERY_PROTECTION_WARNING_MODELS: MODEL_KEY[] = [
  "DR750G Pro",
  "DR750G-1CH Pro",
  "DR750G-2CH Pro",
  "BlackVue 7G Pro",
  // mantis - 10299 Recording Mode setting G Model인 경우 설정 변경 경고 팝업창 출력을 위한 모델추가 (Leehj)
  "DR800 GOLD",
];

export const HDR_RESTARTING_MODEL: MODEL_KEY[] = [
  "DR900S-1CH",
  "DR900S-2CH",
  "DR900X-1CH",
  "DR900X-2CH",
  "DR750G-1CH Pro",
  "DR750G-2CH Pro",
  "DR750G Pro",
];

export const UnableAddCameraPSN4 = [
  "D65G",
  "DR65",
  "D65S",
  "DR6S",
  "59X1",
  "59X2",
];

export const PSN650 = ["D65G", "DR65", "D65S", "DR6S"];

// 옵션 카메라로 표시되는 모델 추가 8487/
export const OPTION_CAMERA_MODELS: MODEL_KEY[] = ["DR770X Box"];

export const TOUCH_SENSOR_MODELS: MODEL_KEY[] = [
  "DR770X",
  "BlackVue 7G Pro",
  "DR770X LTE",
  "DR970X",
  "DR970X LTE",
  "DR800 GOLD",
];

// WifiSleepMode 표시 안되는 모델 추가 8653
export const NON_WIFI_SLEEP_MODELS: MODEL_KEY[] = [
  "DR770X",
  "DR770X Box",
  "DR770X LTE",
  "BlackVue 7G Pro",
  "DR970X",
  "DR970X LTE",
];

// Sigmastar 모델 추가
export const SIGMASTAR_MODELS: MODEL_KEY[] = [
  "DR770X",
  "DR770X Box",
  "DR770X LTE",
  "BlackVue 7G Pro",
  "DR970X",
  "DR970X LTE",
  "DR800 GOLD",
];

// 클라우드 사용 가능한 구모델 추가(Leehj)
export const ENABLED_CLOUD_OLD_MODELS = [
  // 구모델
  "DR650GW-1CH",
  "DR650GW-2CH",
  "DR650S-1CH",
  "DR650S-2CH",
  "DR750S-1CH",
  "DR750S-2CH",
  "DR900S-1CH",
  "DR900S-2CH",
  "DR750X-1CH",
  "DR750X-2CH",
  "DR900X-1CH",
  "DR900X-2CH",
  "DR750-2CH LTE",
  "DR750G-1CH",
  "DR750G-2CH",
  "DR750G-1CH Pro",
  "DR750G-2CH Pro",
  "DR750G Pro",
];

// 신모델 추가(Leehj)
export const NEW_MODELS = [
  "DR750X Plus",
  "DR750X LTE Plus",
  "DR750X-3CH Plus",
  "DR900X Plus",
];

// 구모델 추가
export const OLD_MODELS = [
  "DR500W-1CH",
  "DR500GW-HD",
  "DR530W-2CH",
  "DR550GW-1CH",
  "DR550GW-2CH",
  "DR590W-1CH",
  "DR590W-2CH",
  "DR590X-1CH",
  "DR590X-2CH",
  "DR600GW-HD",
  "DR750LW-2CH",
  "DR650GW-1CH",
  "DR650GW-2CH",
  "DR650S-1CH",
  "DR650S-2CH",
  "DR750S-1CH",
  "DR750S-2CH",
  "DR900S-1CH",
  "DR900S-2CH",
  "DR750X-1CH",
  "DR750X-2CH",
  "DR900X-1CH",
  "DR900X-2CH",
  "DR750-2CH LTE",
  "DR750G-1CH",
  "DR750G-2CH",
  "DR750G-1CH Pro",
  "DR750G-2CH Pro",
];
